import { Routes } from '@angular/router';
import { LayoutComponent } from '@components/_layout/layout.component';
import { EmptyPageComponent } from '@components/empty-page/empty-page.component';
import { AuthenticatedGuard } from '@guards/authenticated.guard';
import { I18NEXT_NAMESPACE_RESOLVER } from 'angular-i18next';

export const iframePagesWithStandardLayout: Routes = [
  { path: 'Default.aspx', component: EmptyPageComponent },
  { path: 'PartnerLogin.aspx', component: EmptyPageComponent },
  { path: 'ForgotPass.aspx', component: EmptyPageComponent },
  { path: 'ProviderList.aspx', component: EmptyPageComponent },
  { path: 'AddProvider.aspx', component: EmptyPageComponent },
  { path: 'PartnerLicenses.aspx', component: EmptyPageComponent },
  { path: 'PartnerProvider.aspx', component: EmptyPageComponent },
  { path: 'PartnerTransactions.aspx', component: EmptyPageComponent },
  { path: 'LicenseUsage.aspx', component: EmptyPageComponent },
  { path: 'LicenseUsageHistory.aspx', component: EmptyPageComponent },
  { path: 'EditAccount.aspx', component: EmptyPageComponent },
  { path: 'ParthnersProfile.aspx', component: EmptyPageComponent },
  { path: 'Help.aspx', component: EmptyPageComponent }
];

export const guardedPagesWithStandardLayout: Routes = [
  {
    path: 'PurchaseHistory',
    data: { i18nextNamespaces: ['purchase-history'] },
    resolve: { i18next: I18NEXT_NAMESPACE_RESOLVER },
    loadChildren: () => import('mbs-ui-shared@components/purchase-history/purchase-history.routes').then((r) => r.PURCHASE_HISTORY_ROUTES)
  }
];

export const routes: Routes = [
  {
    path: 'AP',
    component: LayoutComponent,
    children: [
      ...iframePagesWithStandardLayout,
      {
        path: '',
        canActivateChild: [AuthenticatedGuard],
        children: [...guardedPagesWithStandardLayout]
      }
    ]
  },
  { path: '**', redirectTo: '/AP/Default.aspx' }
];
